import { apiGet, apiPost } from './http-client';

/** Раздел входа: клиентское приложение/виджет, приложение тренера, CRM. */
export type LoginSurface = 'client' | 'trainer' | 'staff';

/** Вариант в окне «Войти как…» / «Выберите студию». Подписи формирует сервер. */
export type LoginContextOption = {
  id: string;
  surface: LoginSurface | string;
  org_id: number;
  org_name: string;
  role: string;
  label: string;
};

/** Ответ login/2FA/call-status, когда нужно выбрать раздел. */
export type ContextRequiredResponse = {
  status: 'context_required';
  contexts: LoginContextOption[];
  selection_token: string;
  expires_in?: number;
};

export type AuthTokenPair = {
  access_token: string;
  refresh_token?: string | null;
  token_type?: string;
  expires_in?: number;
};

export type AuthContextsResponse = {
  current: LoginContextOption | null;
  available: LoginContextOption[];
};

export function isContextRequired(
  value: unknown
): value is ContextRequiredResponse {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  return (
    v.status === 'context_required' &&
    Array.isArray(v.contexts) &&
    typeof v.selection_token === 'string'
  );
}

/** POST /api/v1/auth/select-context — выбор раздела после подтверждения личности. */
export function postAuthSelectContext(
  selectionToken: string,
  contextId: string
): Promise<AuthTokenPair> {
  return apiPost<AuthTokenPair>('/api/v1/auth/select-context', {
    selection_token: selectionToken,
    context_id: contextId
  });
}

/** GET /api/v1/auth/contexts — текущий и доступные разделы для «Сменить роль». */
export function getAuthContexts(accessToken: string): Promise<AuthContextsResponse> {
  return apiGet<AuthContextsResponse>('/api/v1/auth/contexts', undefined, { accessToken });
}

/** POST /api/v1/auth/switch-context — новый токен другого раздела (старая сессия отзывается). */
export function postAuthSwitchContext(
  contextId: string,
  accessToken: string
): Promise<AuthTokenPair> {
  return apiPost<AuthTokenPair>(
    '/api/v1/auth/switch-context',
    { context_id: contextId },
    { accessToken }
  );
}
